// import React, { useState, useEffect, useContext, useMemo } from "react";
// import Grid from "@mui/material/Grid";
// import Card from "@mui/material/Card";
// import Alert from "@mui/material/Alert";
// import TextField from "@mui/material/TextField";
// import CircularProgress from "@mui/material/CircularProgress";
// import axios from "axios";
// import { useLocation } from "react-router-dom";

// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import Autocomplete from "@mui/material/Autocomplete";

// // New MUI components for custom filter
// import Popover from "@mui/material/Popover";
// import FormGroup from "@mui/material/FormGroup";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
// import IconButton from "@mui/material/IconButton";
// import Icon from "@mui/material/Icon";

// import MDBox from "components/MDBox";
// import MDButton from "components/MDButton";
// import MDSnackbar from "components/MDSnackbar";
// import MDTypography from "components/MDTypography";
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// import ReportsTable from "./notificationTable"; // Ensure this imports your updated ReportsTable.js
// import { notificationlogsendpoint } from "config";
// import { AccountsContext } from "context/AccountsContext";
// import DateRangePicker from "layouts/DateTimerange/dateTimeRange";
// import DhundhooLoader from "../Loader/Loader";

// // ==========================================
// // CUSTOM FILTER LOGIC & COMPONENT
// // ==========================================

// const multiSelectFilterFn = (rows, id, filterValues) => {
//   if (!filterValues || filterValues.length === 0) return rows;
//   return rows.filter((row) => filterValues.includes(row.values[id]));
// };

// // Custom Dropdown Checkbox UI for Event Type Filter
// const EventTypeFilter = ({ column: { filterValue, setFilter, preFilteredRows, id } }) => {
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [selectedOptions, setSelectedOptions] = useState(filterValue || []);

//   const options = useMemo(() => {
//     // Default options jo hamesha dikhenge
//     const opts = new Set(["GEOFENCE", "ETA", "RFID"]); 

//     // Agar api response me koi naya type aata hai, to wo bhi add ho jayega
//     preFilteredRows.forEach((row) => {
//       if (row.values[id]) opts.add(row.values[id]);
//     });

//     return [...opts.values()];
//   }, [id, preFilteredRows]);

//   useEffect(() => {
//     setSelectedOptions(filterValue || []);
//   }, [filterValue]);

//   const handleClick = (event) => setAnchorEl(event.currentTarget);
//   const handleClose = () => setAnchorEl(null);

//   const handleToggle = (opt) => {
//     setSelectedOptions((prev) =>
//       prev.includes(opt) ? prev.filter((item) => item !== opt) : [...prev, opt]
//     );
//   };

//   const handleApply = () => {
//     setFilter(selectedOptions.length ? selectedOptions : undefined);
//     handleClose();
//   };

//   const handleReset = () => {
//     setSelectedOptions([]);
//     setFilter(undefined);
//     handleClose();
//   };

//   return (
//     <>
//       <IconButton size="small" onClick={handleClick} sx={{ ml: 1, p: 0 }}>
//         <Icon fontSize="small" sx={{ color: filterValue?.length ? "#00bcd4" : "#999" }}>
//           filter_alt
//         </Icon>
//       </IconButton>

//     <Popover
//         open={Boolean(anchorEl)}
//         anchorEl={anchorEl}
//         onClose={handleClose}
//         // 👇 Inko "center" karne se modal bilkul icon ke neeche aayega
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//         transformOrigin={{ vertical: "top", horizontal: "center" }}
//         PaperProps={{
//           sx: {
//             backgroundColor: "#f5f6f8", 
//             border: "1px solid #d2d6da", 
//             boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.15)", 
//             mt: 0.5, 
//           }
//         }}
//       >
//         <MDBox p={2} minWidth="150px">
//           <FormGroup>
//             {options.map((opt, i) => (
//               <FormControlLabel
//                 key={i}
//                 control={
//                   <Checkbox
//                     size="small"
//                     checked={selectedOptions.includes(opt)}
//                     onChange={() => handleToggle(opt)}
//                     sx={{
//                       color: "#7b809a", // Unchecked color
//                       "&.Mui-checked": {
//                         color: "#1A73E8", // Checked blue color
//                       },
//                     }}
//                   />
//                 }
//                 label={<MDTypography variant="button" color="text" fontWeight="medium">{opt}</MDTypography>}
//               />
//             ))}
//           </FormGroup>
//           <MDBox display="flex" justifyContent="space-between" mt={1} pt={1} borderTop="1px solid #d2d6da">
//             <MDButton variant="text" color="info" size="small" onClick={handleApply}>
//               OK
//             </MDButton>
//             <MDButton variant="text" color="info" size="small" onClick={handleReset}>
//               Reset
//             </MDButton>
//           </MDBox>
//         </MDBox>
//       </Popover>
//     </>
//   );
// };

// // ==========================================
// // MAIN COMPONENT
// // ==========================================

// function NotificationLogs() {
//   const location = useLocation();
//   const autoFetchVehicleId = location.state?.autoFetchVehicleId || "";

//   const [notificationData, setNotificationData] = useState([]);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [successSB, setSuccessSB] = useState(false);
//   const [errorSB, setErrorSB] = useState(false);
//   const [vehicleId, setVehicleId] = useState(autoFetchVehicleId);
//   const [loading, setLoading] = useState(false);

//   const { fetchThings, things } = useContext(AccountsContext);

//   useEffect(() => {
//     fetchThings();
//     if (autoFetchVehicleId) {
//       fetchLogs(autoFetchVehicleId);
//     }
//   }, []);

//   const getTodayDateString = () => {
//     const today = new Date();
//     const y = today.getFullYear();
//     const m = String(today.getMonth() + 1).padStart(2, '0');
//     const d = String(today.getDate()).padStart(2, '0');
//     return `${y}-${m}-${d}`;
//   };

//   const todayStr = getTodayDateString();
//   const defaultStart = `${todayStr}T00:00`;
//   const defaultEnd = `${todayStr}T23:59`;

//   const [startTime, setStartTime] = useState(defaultStart);
//   const [endTime, setEndTime] = useState(defaultEnd);

//   const openSuccessSB = () => setSuccessSB(true);
//   const closeSuccessSB = () => setSuccessSB(false);
//   const openErrorSB = () => setErrorSB(true);
//   const closeErrorSB = () => setErrorSB(false);

//   // Column configuration with Custom Filter
//   const columns = [
//     { Header: "Timestamp", accessor: "updatedAt", width: "20%", disableFilters: true },
//     { 
//       Header: "Event Type", 
//       accessor: "eventType", 
//       width: "10%",
//       Filter: EventTypeFilter,
//       filter: multiSelectFilterFn,
//     },
//     { Header: "Message", accessor: "message", width: "50%", disableFilters: true },
//     { Header: "Delivered To", accessor: "toAccount", width: "20%", disableFilters: true },
//   ];

//   const fetchLogs = async (overrideVehicleId) => {
//     const finalVehicleId = typeof overrideVehicleId === "string" && overrideVehicleId.trim()
//       ? overrideVehicleId
//       : vehicleId;

//     if (!startTime || !endTime) {
//       setErrorMessage("Please select a date range first.");
//       openErrorSB();
//       return;
//     }

//     if (!finalVehicleId) {
//       setErrorMessage("Please select a vehicle.");
//       openErrorSB();
//       return;
//     }

//     setLoading(true);
//     setErrorMessage("");

//     try {
//       const data = JSON.stringify({
//         thingId: finalVehicleId, 
//         startTime: new Date(startTime).getTime(),
//         endTime: new Date(endTime).getTime(),
//       });

//       const config = {
//         method: "post",
//         maxBodyLength: Infinity,
//         url: notificationlogsendpoint,
//         headers: { "Content-Type": "application/json" },
//         data,
//       };

//       const response = await axios.request(config);

//       const formattedRows = response.data.map((log) => ({
//         updatedAt: new Date(log.updatedAt).toLocaleString("en-GB"),
//         eventType: log.eventType,
//         message: log.message,
//         toAccount: log.toAccount,
//       }));

//       setNotificationData(formattedRows);
//       openSuccessSB();
//     } catch (error) {
//       console.error(error);
//       setErrorMessage("Error loading notification logs");
//       openErrorSB();
//     } finally {
//       setLoading(false);
//     }
//   };

//   const exportToCSV = () => {
//     if (notificationData.length === 0) {
//       setErrorMessage("No data to export");
//       openErrorSB();
//       return;
//     }

//     const formatFileDate = (dateTime) => {
//       if (!dateTime) return "";
//       const date = new Date(dateTime);
//       const day = String(date.getDate()).padStart(2, "0");
//       const month = String(date.getMonth() + 1).padStart(2, "0");
//       const year = date.getFullYear();
//       return `${day}-${month}-${year}`;
//     };

//     const formattedDate = `${formatFileDate(startTime)}_to_${formatFileDate(endTime)}`;

//     const headers = ["Timestamp", "Event Type", "Message", "Delivered To"];
//     const rows = notificationData.map((row) =>
//       [row.updatedAt, row.eventType, `"${row.message}"`, row.toAccount].join(",")
//     );
//     const csvContent = [headers.join(","), ...rows].join("\n");

//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//     const url = URL.createObjectURL(blob);

//     const link = document.createElement("a");
//     link.setAttribute("href", url);
//     link.setAttribute("download", `NotificationLogs_${formattedDate}.csv`);
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   const handleClear = () => {
//     setVehicleId("");
//     setStartTime(defaultStart); 
//     setEndTime(defaultEnd);
//     setNotificationData([]);
//     setErrorMessage("");
//   };

//   return (
//     <DashboardLayout>
//       <DashboardNavbar />
//       <MDBox>
//         <Grid container spacing={6}>
//           <Grid item xs={12}>
//             <Card>
//               <MDBox p={3} pb={0}>
//                 <LocalizationProvider dateAdapter={AdapterDateFns}>
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} sm={6} md={3}>
//                       <Autocomplete
//                         disablePortal
//                         options={things || []}
//                         getOptionLabel={(option) => option.thingId || ""}
//                         value={things?.find((t) => t.thingId === vehicleId) || null}
//                         onChange={(event, newValue) => {
//                           setVehicleId(newValue ? newValue.thingId : "");
//                         }}
//                         renderOption={(props, option) => (
//                           <li
//                             {...props}
//                             key={option.thingId}
//                             style={{
//                               display: "flex",
//                               justifyContent: "space-between",
//                               width: "100%",
//                             }}
//                           >
//                             <span>{option.nickName}</span>
//                             <span style={{ color: "#666" }}>{option.thingId}</span>
//                           </li>
//                         )}
//                         renderInput={(params) => (
//                           <TextField
//                             {...params}
//                             placeholder="Search or add vehicle number"
//                             fullWidth
//                             size="small"
//                             sx={{
//                               "& .MuiOutlinedInput-root": {
//                                 "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//                                   borderColor: "#FB8C00", 
//                                 },
//                               },
//                               "& .MuiInputLabel-root.Mui-focused": {
//                                 color: "#FB8C00", 
//                               },
//                             }}
//                           />
//                         )}
//                       />
//                     </Grid>

//                     <Grid item xs={12} md={6}>
//                       <div style={{ width: '46%' }}>
//                         <DateRangePicker
//                           startTime={startTime}
//                           endTime={endTime}
//                           onChange={({ startTime: s, endTime: e }) => {
//                             setStartTime(s);
//                             setEndTime(e);
//                           }}
//                           disabled={loading}
//                         />
//                       </div>
//                     </Grid>

//                     <Grid item xs={4} sm={2} md={1}>
//                       <MDButton
//                         fullWidth
//                         variant="gradient"
//                         color="warning"
//                         size="small"
//                         onClick={() => fetchLogs()} 
//                         disabled={loading}
//                       >
//                         {loading ? <CircularProgress size={20} color="inherit" /> : "LOAD"}
//                       </MDButton>
//                     </Grid>
//                     <Grid item xs={4} sm={2} md={1}>
//                       <MDButton
//                         fullWidth
//                         variant="outlined"
//                         color="error"
//                         size="small"
//                         onClick={handleClear}
//                         disabled={loading}
//                       >
//                         CLEAR
//                       </MDButton>
//                     </Grid>
//                     <Grid item xs={4} sm={2} md={1}>
//                       <MDButton
//                         fullWidth
//                         variant="gradient"
//                         color="secondary"
//                         size="small"
//                         onClick={exportToCSV}
//                         disabled={loading}
//                       >
//                         CSV
//                       </MDButton>
//                     </Grid>
//                   </Grid>
//                 </LocalizationProvider>
//               </MDBox>

//               {errorMessage && (
//                 <MDBox px={2} pt={2}>
//                   <Alert severity="error">{errorMessage}</Alert>
//                 </MDBox>
//               )}

//               <MDBox pt={3} display="flex" justifyContent="center" width="100%">
//                 {loading ? (
//                   <DhundhooLoader /> 
//                 ) : (
//                   <ReportsTable
//                     table={{ columns, rows: notificationData }}
//                     isSorted={false}
//                     entriesPerPage={false}
//                     showTotalEntries={true}
//                     noEndBorder
//                   />
//                 )}
//               </MDBox>
//             </Card>
//           </Grid>
//         </Grid>
//       </MDBox>

//       <MDSnackbar
//         color="success"
//         icon="check"
//         title="Notification Logs"
//         content="Data Loaded Successfully"
//         open={successSB}
//         onClose={closeSuccessSB}
//         close={closeSuccessSB}
//         bgWhite
//       />
//       <MDSnackbar
//         color="error"
//         icon="warning"
//         title="Notification Logs"
//         content={errorMessage || "Failed to load logs. Please try again."}
//         open={errorSB}
//         onClose={closeErrorSB}
//         close={closeErrorSB}
//         bgWhite
//       />
//     </DashboardLayout>
//   );
// }

// export default NotificationLogs;

import React, { useState, useEffect, useContext, useMemo } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Alert from "@mui/material/Alert";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import { useLocation } from "react-router-dom";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Autocomplete from "@mui/material/Autocomplete";

// New MUI components for custom filter
import Popover from "@mui/material/Popover";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DownloadExcelButton from "components/ReportUI/Downloadexcelbutton";
import RowExportIcon from "components/ReportUI/Rowexporticon";
import TypeBadge from "components/ReportUI/Typebadge";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Icons for row-level polish
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import NfcIcon from "@mui/icons-material/Nfc";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import ScheduleIcon from "@mui/icons-material/Schedule";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";

import ReportsTable from "./notificationTable"; // Ensure this imports your updated ReportsTable.js
import { notificationlogsendpoint } from "config";
import { AccountsContext } from "context/AccountsContext";
import DateRangePicker from "layouts/DateTimerange/dateTimeRange";
import DhundhooLoader from "../Loader/Loader";

// ==========================================
// CUSTOM FILTER LOGIC & COMPONENT
// ==========================================

const multiSelectFilterFn = (rows, id, filterValues) => {
  if (!filterValues || filterValues.length === 0) return rows;
  return rows.filter((row) => filterValues.includes(row.values[id]));
};

// Custom Dropdown Checkbox UI for Event Type Filter
const EventTypeFilter = ({ column: { filterValue, setFilter, preFilteredRows, id } }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState(filterValue || []);

  const options = useMemo(() => {
    // Default options jo hamesha dikhenge
    const opts = new Set(["GEOFENCE", "ETA", "RFID"]);

    // Agar api response me koi naya type aata hai, to wo bhi add ho jayega
    preFilteredRows.forEach((row) => {
      if (row.values[id]) opts.add(row.values[id]);
    });

    return [...opts.values()];
  }, [id, preFilteredRows]);

  useEffect(() => {
    setSelectedOptions(filterValue || []);
  }, [filterValue]);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleToggle = (opt) => {
    setSelectedOptions((prev) =>
      prev.includes(opt) ? prev.filter((item) => item !== opt) : [...prev, opt]
    );
  };

  const handleApply = () => {
    setFilter(selectedOptions.length ? selectedOptions : undefined);
    handleClose();
  };

  const handleReset = () => {
    setSelectedOptions([]);
    setFilter(undefined);
    handleClose();
  };

  return (
    <>
      <IconButton size="small" onClick={handleClick} sx={{ ml: 1, p: 0 }}>
        <Icon fontSize="small" sx={{ color: filterValue?.length ? "#00bcd4" : "#999" }}>
          filter_alt
        </Icon>
      </IconButton>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        // 👇 Inko "center" karne se modal bilkul icon ke neeche aayega
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        PaperProps={{
          sx: {
            backgroundColor: "#f5f6f8",
            border: "1px solid #d2d6da",
            boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.15)",
            mt: 0.5,
          }
        }}
      >
        <MDBox p={2} minWidth="150px">
          <FormGroup>
            {options.map((opt, i) => (
              <FormControlLabel
                key={i}
                control={
                  <Checkbox
                    size="small"
                    checked={selectedOptions.includes(opt)}
                    onChange={() => handleToggle(opt)}
                    sx={{
                      color: "#7b809a", // Unchecked color
                      "&.Mui-checked": {
                        color: "#1A73E8", // Checked blue color
                      },
                    }}
                  />
                }
                label={<MDTypography variant="button" color="text" fontWeight="medium">{opt}</MDTypography>}
              />
            ))}
          </FormGroup>
          <MDBox display="flex" justifyContent="space-between" mt={1} pt={1} borderTop="1px solid #d2d6da">
            <MDButton variant="text" color="info" size="small" onClick={handleApply}>
              OK
            </MDButton>
            <MDButton variant="text" color="info" size="small" onClick={handleReset}>
              Reset
            </MDButton>
          </MDBox>
        </MDBox>
      </Popover>
    </>
  );
};

// ==========================================
// MAIN COMPONENT
// ==========================================

function NotificationLogs() {
  const location = useLocation();
  const autoFetchVehicleId = location.state?.autoFetchVehicleId || "";

  const [notificationData, setNotificationData] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
  const [vehicleId, setVehicleId] = useState(autoFetchVehicleId);
  const [loading, setLoading] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");

  const { fetchThings, things } = useContext(AccountsContext);

  useEffect(() => {
    fetchThings();
    if (autoFetchVehicleId) {
      fetchLogs(autoFetchVehicleId);
    }
  }, []);

  const getTodayDateString = () => {
    const today = new Date();
    const y = today.getFullYear();
    const m = String(today.getMonth() + 1).padStart(2, '0');
    const d = String(today.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  const todayStr = getTodayDateString();
  const defaultStart = `${todayStr}T00:00`;
  const defaultEnd = `${todayStr}T23:59`;

  const [startTime, setStartTime] = useState(defaultStart);
  const [endTime, setEndTime] = useState(defaultEnd);

  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);

  // Column configuration with Custom Filter
  // Export a single row as CSV
  const exportSingleRow = (row) => {
    const headers = ["Timestamp", "Event Type", "Message", "Delivered To"];
    const values = [row.updatedAt, row.eventType, row.message, row.toAccount];
    const csvContent = [headers.join(","), values.map((v) => (v ?? "")).join(",")].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `Row_Export_${Date.now()}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Event type -> color/icon mapping for the badge
  const eventTypeConfig = {
    GEOFENCE: { color: "#1D6F42", bg: "#E9F9EE", icon: <LocationOnIcon fontSize="inherit" /> },
    ETA: { color: "#B45309", bg: "#FFF7E6", icon: <AccessTimeIcon fontSize="inherit" /> },
    RFID: { color: "#5B21B6", bg: "#F3EEFF", icon: <NfcIcon fontSize="inherit" /> },
  };
  const eventTypeDefault = { color: "#1E40AF", bg: "#E9F1FF", icon: <NotificationsActiveIcon fontSize="inherit" /> };

  // Delivered To -> pick email vs phone icon
  const renderDeliveredTo = (value) => {
    if (!value) return "-";
    const isEmail = String(value).includes("@");
    return (
      <MDBox display="flex" alignItems="center" gap={0.75}>
        {isEmail ? (
          <EmailOutlinedIcon fontSize="small" sx={{ color: "#B0B7C3" }} />
        ) : (
          <PhoneOutlinedIcon fontSize="small" sx={{ color: "#B0B7C3" }} />
        )}
        <MDTypography variant="caption" fontWeight="regular" color="secondary">
          {value}
        </MDTypography>
      </MDBox>
    );
  };

  const columns = [
    {
      Header: "Timestamp",
      accessor: "updatedAt",
      width: "18%",
      disableFilters: true,
      Cell: ({ value }) => (
        <MDBox display="flex" alignItems="center" gap={0.75}>
          <ScheduleIcon fontSize="small" sx={{ color: "#B0B7C3" }} />
          <MDTypography variant="caption" fontWeight="regular" color="secondary">
            {value}
          </MDTypography>
        </MDBox>
      ),
    },
    {
      Header: "Event Type",
      accessor: "eventType",
      width: "12%",
      Filter: EventTypeFilter,
      filter: multiSelectFilterFn,
      Cell: ({ value }) => <TypeBadge value={value} config={eventTypeConfig} defaultConfig={eventTypeDefault} />,
    },
    {
      Header: "Message",
      accessor: "message",
      width: "45%",
      disableFilters: true,
      Cell: ({ value }) => (
        <MDTypography variant="button" fontWeight="regular" sx={{ color: "#2D3748" }}>
          {value}
        </MDTypography>
      ),
    },
    {
      Header: "Delivered To",
      accessor: "toAccount",
      width: "15%",
      disableFilters: true,
      Cell: ({ value }) => renderDeliveredTo(value),
    },
  ];

  const fetchLogs = async (overrideVehicleId) => {
    const finalVehicleId = typeof overrideVehicleId === "string" && overrideVehicleId.trim()
      ? overrideVehicleId
      : vehicleId;

    if (!startTime || !endTime) {
      setErrorMessage("Please select a date range first.");
      openErrorSB();
      return;
    }

    if (!finalVehicleId) {
      setErrorMessage("Please select a vehicle.");
      openErrorSB();
      return;
    }

    // agar mobile number diya hai to wo pura 10 digit hona chahiye
    if (mobileNumber && mobileNumber.trim().length !== 10) {
      setErrorMessage("Please enter a valid 10 digit mobile number.");
      openErrorSB();
      return;
    }

    setLoading(true);
    setErrorMessage("");

    try {
      const payload = {
        thingId: finalVehicleId,
        startTime: new Date(startTime).getTime(),
        endTime: new Date(endTime).getTime(),
      };

      // toAccount sirf tab add karo jab mobile number diya ho
      if (mobileNumber && mobileNumber.trim().length === 10) {
        payload.toAccount = `91${mobileNumber.trim()}`;
      }

      const data = JSON.stringify(payload);

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: notificationlogsendpoint,
        headers: { "Content-Type": "application/json" },
        data,
      };

      const response = await axios.request(config);

      const formattedRows = response.data.map((log) => ({
        updatedAt: new Date(log.updatedAt).toLocaleString("en-GB"),
        eventType: log.eventType,
        message: log.message,
        toAccount: log.toAccount,
      }));

      setNotificationData(formattedRows);
      openSuccessSB();
    } catch (error) {
      console.error(error);
      setErrorMessage("Error loading notification logs");
      openErrorSB();
    } finally {
      setLoading(false);
    }
  };

  const exportToCSV = () => {
    if (notificationData.length === 0) {
      setErrorMessage("No data to export");
      openErrorSB();
      return;
    }

    const formatFileDate = (dateTime) => {
      if (!dateTime) return "";
      const date = new Date(dateTime);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    const formattedDate = `${formatFileDate(startTime)}_to_${formatFileDate(endTime)}`;

    const headers = ["Timestamp", "Event Type", "Message", "Delivered To"];
    const rows = notificationData.map((row) =>
      [row.updatedAt, row.eventType, `"${row.message}"`, row.toAccount].join(",")
    );
    const csvContent = [headers.join(","), ...rows].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `NotificationLogs_${formattedDate}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleClear = () => {
    setVehicleId("");
    setStartTime(defaultStart);
    setEndTime(defaultEnd);
    setNotificationData([]);
    setErrorMessage("");
    setMobileNumber("");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
     <MDBox
      sx={{
        minHeight: {
          xs: "calc(100vh - 140px)",
          sm: "calc(100vh - 120px)",
          md: "calc(100vh - 90px)",
        },
        display: "flex",
        flexDirection: "column",
      }}
    >
        <Grid container spacing={6} sx={{ flex: 1 }}>
          <Grid item xs={12}>
            <Card sx={{ height: "100%" }}>
              <MDBox p={3} pb={0}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={3}>
                      <Autocomplete
                        disablePortal
                        options={things || []}
                        getOptionLabel={(option) => option.thingId || ""}
                        filterOptions={(options, { inputValue }) => {
                          const searchValue = inputValue.toLowerCase().trim();

                          return options.filter((option) => {
                            const thingId = (option.thingId || "").toLowerCase();
                            const nickName = (option.nickName || "").toLowerCase();

                            return (
                              thingId.includes(searchValue) ||
                              nickName.includes(searchValue)
                            );
                          });
                        }}
                        value={things?.find((t) => t.thingId === vehicleId) || null}
                        onChange={(event, newValue) => {
                          setVehicleId(newValue ? newValue.thingId : "");
                        }}
                        renderOption={(props, option) => (
                          <li
                            {...props}
                            key={option.thingId}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            <span>{option.nickName || "-"}</span>

                            <span style={{ color: "#666" }}>
                              {option.thingId}
                            </span>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Search vehicle or nickname"
                            fullWidth
                            size="small"
                            sx={{
                              fontFamily: '"Poppins", "Helvetica", "Arial", sans-serif',

                              "& .MuiOutlinedInput-root": {
                                fontFamily: '"Poppins", "Helvetica", "Arial", sans-serif',
                                fontSize: "0.875rem",

                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#FB8C00",
                                },
                              },

                              "& .MuiInputLabel-root.Mui-focused": {
                                color: "#FB8C00",
                              },
                            }}
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} md={2}>
                      <TextField
                        placeholder="10 digit phone number"
                        fullWidth
                        size="small"
                        value={mobileNumber}
                        onChange={(e) => {
                          const val = e.target.value.replace(/\D/g, "").slice(0, 10);
                          setMobileNumber(val);
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#FB8C00",
                            },
                          },
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <div style={{ width: '46%' }}>
                        <DateRangePicker
                          startTime={startTime}
                          endTime={endTime}
                          onChange={({ startTime: s, endTime: e }) => {
                            setStartTime(s);
                            setEndTime(e);
                          }}
                          disabled={loading}
                        />
                      </div>
                    </Grid>

                    <Grid item xs={4} sm={2} md={1}>
                      <MDButton
                        fullWidth
                        variant="gradient"
                        color="warning"
                        size="small"
                        onClick={() => fetchLogs()}
                        disabled={loading}
                      >
                        {loading ? <CircularProgress size={20} color="inherit" /> : "LOAD"}
                      </MDButton>
                    </Grid>
                    <Grid item xs={4} sm={2} md={1}>
                      <MDButton
                        fullWidth
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={handleClear}
                        disabled={loading}
                      >
                        CLEAR
                      </MDButton>
                    </Grid>
                    <Grid item xs={4} sm={2} md={1}>
                      <DownloadExcelButton fullWidth label="CSV" onClick={exportToCSV} disabled={loading} />
                    </Grid>
                  </Grid>
                </LocalizationProvider>
              </MDBox>

              {errorMessage && (
                <MDBox px={2} pt={2}>
                  <Alert severity="error">{errorMessage}</Alert>
                </MDBox>
              )}

              <MDBox pt={3} display="flex" justifyContent="center" width="100%">
                {loading ? (
                  <DhundhooLoader />
                ) : (
                  <ReportsTable
                    table={{ columns, rows: notificationData }}
                    isSorted={false}
                    entriesPerPage={{ defaultValue: 10, entries: [10, 25, 50, 100] }}
                    showTotalEntries={true}
                    noEndBorder
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <MDSnackbar
        color="success"
        icon="check"
        title="Notification Logs"
        content="Data Loaded Successfully"
        open={successSB}
        onClose={closeSuccessSB}
        close={closeSuccessSB}
        bgWhite
      />
      <MDSnackbar
        color="error"
        icon="warning"
        title="Notification Logs"
        content={errorMessage || "Failed to load logs. Please try again."}
        open={errorSB}
        onClose={closeErrorSB}
        close={closeErrorSB}
        bgWhite
      />
    </DashboardLayout>
  );
}

export default NotificationLogs;